import React from 'react'

import {
  getAddress,
} from 'helpers'

import ContactModal from 'components/atoms/ContactModal'

import './index.scss'

const handleWebsiteLinkTrigger = (e, tracking_url) => {
  e.stopPropagation()
  e.preventDefault()

  window.open(tracking_url, '_blank')
}

const handleMapLinkTrigger = (e, destination_url, tracking_url) => {
  e.stopPropagation()
  e.preventDefault()

  const redirect = (url, src) => {
    window.location.href = destination_url
  }

  // Fire tracking URL.
  let img = new Image()
  // img.onerror = redirect(destination_url, 'error')
  img.onload = redirect(destination_url, 'load')
  img.src = `${tracking_url}?_=${new Date().getTime()}`
}

const generateMapLink = address => {
  // Temporary until they get the map_url thing working again.
  if(address?.latitude && address?.longitude){
    return <div className="trigger"><a href={`https://www.google.com/maps/place/${encodeURIComponent(getAddress(address))}/@${address.latitude},${address.longitude}`}>Map &amp; Directions</a></div>
  }
  return null
}

const ExternalLinks = ({
  urls = {},
  address = {},
  businessName = '',
  businessSecuredEmail = '',
  businessId = '',
  businessPhone = ''
}) => {
  const [ state, setState ] = React.useState({
    showContactModal: false,
  })

  const handleContactClick = (e, tracking_url) => {
    e.stopPropagation()
    e.preventDefault()

    // Fire tracking URL.
    let img = new Image()
    // img.onerror = redirect(destination_url, 'error')
    img.onload = setState({
      ...state,
      showContactModal: true,
    })
    img.src = `${tracking_url}?_=${new Date().getTime()}`
  }

  return <React.Fragment>
    <div className="external-links-container">
      {generateMapLink(address)}
      {false && urls?.map_url && <div className="trigger"><a onClick={ e => handleMapLinkTrigger(e, `https://www.google.com/maps/place/${encodeURIComponent(getAddress(address))}/@${address.latitude},${address.longitude}`, urls.map_url)} href={`https://www.google.com/maps/place/${encodeURIComponent(getAddress(address))}/@${address.latitude},${address.longitude}`}>Map &amp; Directions</a></div>}
      {urls?.website_url && <div className="trigger"><a onClick={ e => handleWebsiteLinkTrigger(e, urls.website_url)} href={urls.website_url}>Website</a></div>}
      {
        // Re-enable these as the APIs are improved
      }
      { false && <React.Fragment>
        <div className="trigger"><a href="#" onClick={ e => handleContactClick(e, urls.email_link)}>Contact</a></div>
        {urls?.reviews_url && <div className="trigger"><a onClick={ e => handleExternalLinkTrigger(e, urls.reviews_url)} href={urls.reviews_url}>Reviews</a></div>}
        {urls?.send_to_friend_url && <div className="trigger"><a onClick={ e => handleExternalLinkTrigger(e, urls.video_url)} href={urls.video_url}>Send to a Friend</a></div>}
        {urls?.email_link && <div className="trigger"><a onClick={ e => handleExternalLinkTrigger(e, urls.email_link)} href={urls.email_link}>Contact</a></div>}
      </React.Fragment>}
    </div>
    <ContactModal
      show={state.showContactModal}
      handleClose={ () => setState({ ...state, showContactModal: false }) }
      businessName={businessName}
      businessSecuredEmail={businessSecuredEmail}
      businessId={businessId}
      businessPhone={businessPhone} />
  </React.Fragment>
}

export default ExternalLinks
